var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.88
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrowTop0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6596 10.7288C19.5539 10.7757 19.46 10.8344 19.3779 10.9166L12.301 18.0052C11.9607 18.3455 11.9607 18.9089 12.301 19.2492C12.6414 19.5895 13.2047 19.5895 13.545 19.2492L19.1197 13.6745L19.1197 28.4503C19.1197 28.9315 19.5187 29.3305 19.9999 29.3305C20.4811 29.3305 20.8801 28.9315 20.8801 28.4503L20.8801 13.6628L26.4548 19.2375C26.7951 19.5778 27.3584 19.5778 27.6988 19.2375C27.8748 19.0614 27.957 18.8384 27.957 18.6154C27.957 18.3925 27.8748 18.1695 27.6988 17.9934L20.6219 10.9166C20.5398 10.8344 20.4459 10.7757 20.3403 10.7288C20.1173 10.6466 19.8825 10.6466 19.6596 10.7288Z",
    fill: "#1B1C1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowTop0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowTop);
export default __webpack_public_path__ + "static/media/icon_arrow_top.b1ac5370.svg";
export { ForwardRef as ReactComponent };